// // ©2024 Austin App House. All rights reserved.
// import React from 'react';
// import {MDBCol, MDBRow} from "mdbreact";
// import AddExpense from "./AddExpense";
// import ExpensesList from "./ExpensesList";
//
// const WorkOrderExpenses = (
//     {
//         auth,
//         currentWorkOrder,
//         saveExpense,
//         editExpense,
//         deleteExpense
//     }
// ) => (
//     (auth.user.userType !== 'contractor' || currentWorkOrder.contractor_id === auth.user.id)
//         ? <div style={{textAlign: "left"}} >
//             <hr className="my-4 hrline2"/>
//             <AddExpense
//                 currentWorkOrder={currentWorkOrder}
//                 userType={auth.user.userType}
//                 saveExpense={saveExpense}
//             />
//             <ExpensesList
//                 editExpense={editExpense}
//                 deleteExpense={deleteExpense}
//                 userType={auth.user.userType}
//                 currentWorkOrder={currentWorkOrder}
//             />
//         </div>
//         : null
// )
//
// export default WorkOrderExpenses;
// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import workOrderStatusControl from '../../../../utils/workOrderStatusControl';
import { getISODateOnlyUTC } from '../../../../utils/getDateWithOffset';
import Notification from '../../../notification';
import { localCurrencySettings } from '../../../../utils/constans';
import DatePicker from 'react-datepicker';

const WorkOrderExpenses = ({
  auth,
  currentWorkOrder,
  saveExpense,
  editExpense,
  deleteExpense,
}) => {
  const [date, setDate] = useState(new Date());
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [editingExpense, setEditingExpense] = useState(null);
  const workOrderControlByStatus = workOrderStatusControl(currentWorkOrder?.status || '');

  const userType = auth.user.userType;
  const isContractor = userType === 'contractor';
  const isEditable = isContractor && workOrderControlByStatus.assigned;

  const handleAddExpense = async (e) => {
    e.preventDefault();
    if (!amount || !(amount > 0)) {
      return Notification('warning', { message: 'Please enter a valid amount!' });
    }
    if (!description) {
      return Notification('warning', { message: 'Please enter a description!' });
    }
    const result = await saveExpense({
      amount,
      date: getISODateOnlyUTC(date),
      description,
      workOrderId: currentWorkOrder._id,
    });
    if (result) {
      setAmount('');
      setDescription('');
      setDate(new Date());
    }
  };

  const handleSaveEdit = async (expense) => {
    const result = await editExpense(expense);
    if (result) setEditingExpense(null);
  };

  const handleDelete = async (expense) => {
    await deleteExpense(expense);
  };

  if (auth.user.userType !== 'client' && currentWorkOrder.contractor_id !== auth.user.id) {
    return null;
  }

  return (
    <div className="line_blocks">
      <div className="block_label">Expenses</div>

      {/* List of current expenses */}
      <ul className="info_list">
        {currentWorkOrder.expenses?.length ? (
          currentWorkOrder.expenses.map((expense) => (
            <li key={expense._id}>
              <span>{new Date(expense.date).toLocaleDateString()}</span>
              <span>
                {expense.description} —
                {expense.amount.toLocaleString('en-US', localCurrencySettings)}
              </span>
            </li>
          ))
        ) : (
          <li>
            <span>No expenses added yet.</span>
          </li>
        )}
      </ul>

      {/* Actions / controls */}
      {isEditable && (
        <>
          <div className="field_row">
            <div className="field_name">
              <label>Date</label>
            </div>
            <div className="field_block">
              <DatePicker
                className="form-control coutd"
                dateFormat="MM/dd/yy"
                name="date"
                placeholder="Date"
                selected={date}
                value={date}
                onChange={setDate}
              />
            </div>
          </div>
          <div className="field_row">
            <div className="field_name">
              <label className="field_name" htmlFor="expense-amount">Amount ($)</label>
            </div>
            <div className="field_block">
              <input
                id="expense-amount"
                type="number"
                name="amount"
                className="form-control descheck font11"
                placeholder="Amount ($)"
                value={amount}
                onChange={({ target }) => setAmount(target.value)}
              />
            </div>
          </div>
          <div className="field_row">
            <div className="field_name">
              <label>Type Expense Description</label>
            </div>
            <div className="field_block">
              <textarea
                name="description"
                className="form-control descheck font11"
                placeholder="Type Expense Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
          <br />
          <button
            className="standard_btn dark_btn"
            aria-label="Add expense"
            onClick={handleAddExpense}
            disabled={currentWorkOrder.onHold}
          >
            + Add Expense
          </button>
        </>
        // <ul className="type_list">


        //     <li>
        //         <div className="block_type">
        //             <label style={{ display: 'block', marginBottom: 4 }}>Amount ($)</label>
        //             <input
        //                 type="number"
        //                 className="form-control font11"
        //                 placeholder="Amount"
        //                 value={amount}
        //                 onChange={(e) => setAmount(e.target.value)}
        //             />
        //         </div>
        //     </li>

        //     <li>
        //         <div className="block_type">
        //             <label style={{ display: 'block', marginBottom: 4 }}>Description</label>
        //             <input
        //                 type="text"
        //                 className="form-control font11"
        //                 placeholder="Type Expense Description"
        //                 value={description}
        //                 onChange={(e) => setDescription(e.target.value)}
        //             />
        //         </div>
        //     </li>

        //     <li>
        //         <button
        //             className="block_type"
        //             aria-label="Add expense"
        //             onClick={handleAddExpense}
        //             disabled={currentWorkOrder.onHold}
        //         >
        //             + Add Expense
        //         </button>
        //     </li>
        // </ul>
      )}

      {/* Summary */}
      {currentWorkOrder.expenses?.length > 0 && (
        <div style={{ marginTop: '10px', fontSize: '13px', textAlign: 'right' }}>
          <b>Total:</b>{' '}
          {currentWorkOrder.expenses
            .reduce((acc, cur) => acc + cur.amount, 0)
            .toLocaleString('en-US', localCurrencySettings)}
        </div>
      )}
    </div>
  );
};

export default WorkOrderExpenses;
